import 'react-app-polyfill/stable'
import 'core-js'
import './i18n'

import React from 'react'
import { createRoot } from 'react-dom/client'
import { AuthProvider } from 'react-oidc-context'
import { Provider } from 'react-redux'
import { UserManager, WebStorageStateStore } from 'oidc-client-ts'

import App from './App'
import store from './store'
import { recargarSiFaltaChunk } from './utils'

window.addEventListener('error', (e) => recargarSiFaltaChunk(e.error))
window.addEventListener('unhandledrejection', (e) => recargarSiFaltaChunk(e.reason))

const container = document.getElementById('root')
document.title = process.env.REACT_APP_TITLE || 'Title'
const root = createRoot(container)
const userManager = new UserManager({
  authority: process.env.REACT_APP_KEYCLOAK_URL,
  client_id: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
  // Sin la query: si un login falla, la URL lleva ?state=&code= y cada reintento los acumula
  // hasta que Keycloak rechaza el redirect_uri (bucle). Tras el login solo se conserva la ruta.
  redirect_uri: window.location.origin + window.location.pathname,
  userStore:
    process.env.REACT_APP_ENABLE_AUTOMATIC_SIGN_IN === 'true'
      ? new WebStorageStateStore({ store: window.localStorage })
      : undefined,
})
const onSigninCallback = () => {
  window.history.replaceState({}, document.title, window.location.pathname)
}

root.render(
  <AuthProvider userManager={userManager} onSigninCallback={onSigninCallback}>
    <Provider store={store}>
      <App userManager={userManager} />
    </Provider>
  </AuthProvider>,
)
